import React, { Component } from 'react';
import DisclosureData from './DisclosureData';

class LegalContent extends Component {
    render() {        
        return (
            <div>
                <p>
                    All funds: Investment objective is Asset Allocation. Daily Liquidity. Principal not guaranteed. The tax consequences of owning shares of the funds will vary depending on whether you own them through a taxable or tax-deferred account. Tax consequences result from distribution by the funds of dividend and interest income they have received or capital gains they have generated through their investment activities. Tax consequences also may result when investors sell fund shares after the net asset value has increased or decreased. The fund’s prospectus contains this and other information, and should be read carefully before investing.
                </p>
                <DisclosureData {...this.props}/>

                <div className="disclosure-text mt-3">
                    <p className="text-small text-bold text-italic">
                        You should consider the fund's investment objectives, risks, and charges and expenses carefully before you invest. 
                        The fund's prospectus or summary prospectus, which can be obtained by visiting <a target="_blank" rel="noopener noreferrer" href="http://americancentury.com">www.americancentury.com</a>, 
                        contains this and other information about the fund, and should be read carefully before investing. 
                    </p>
                    <p className="text-smaller text-bold">
                        Data presented reflect past performance. Past performance is no guarantee of future results.
                        Current performance may be higher or lower than the performance shown. Investment return and
                        fund share value will fluctuate, and redemption value may be more or less than original cost. To
                        obtain performance data current to the most recent month-end, please visit <a target="_blank" rel="noopener noreferrer" href="http://www.americancentury.com">www.americancentury.com</a>.
                        <br/>
                        Data assumes reinvestment of dividends and capital gains.
                    </p>
                    <p className="text-smaller">
                        The information is not intended as a personalized recommendation or fiduciary advice and should not be relied upon for investment, accounting, legal or tax advice.  
                    </p>   
                    <p className="text-medium">
                        <a target="_blank" rel="noopener noreferrer" href="https://americancentury.prospectus-express.com/summary.asp?doctype=pros&clientid=amercentll&fundid=02507F191">One Choice Target Date Portfolios prospectus information</a>
                    </p>             
                    <p className="text-smaller">
                        American Century Investment Services, Inc., Distributor  
                    </p>
                </div>
            </div>
        );
    }
}

export default LegalContent;